export const SHOPPING_CART_INDEX_SAVE_SEND_REQUEST =
    'SHOPPING_CART_INDEX_SAVE_SEND_REQUEST';
export const SHOPPING_CART_INDEX_SAVE_FAILED_RECEIVED_RESPONSE =
    'SHOPPING_CART_INDEX_SAVE_FAILED_RECEIVED_RESPONSE';
export const SHOPPING_CART_INDEX_SAVE_SUCCESS_RECEIVED_RESPONSE =
    'SHOPPING_CART_INDEX_SAVE_SUCCESS_RECEIVED_RESPONSE';
export const SHOPPING_CART_INDEX_SAVE_VALIDATION_EXCEPTION =
    'SHOPPING_CART_INDEX_SAVE_VALIDATION_EXCEPTION';
